(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('GeneralInvoicesListController', GeneralInvoicesListController);

    GeneralInvoicesListController.$inject = ['$state', '$stateParams', '$sce', 'InvoicesService'];

    function GeneralInvoicesListController($state, $stateParams, $sce, InvoicesService) {
        var vm = this;

        vm.clients = [];
        vm.name = '';
        vm.email = '';

        vm.message = null;
        vm.classMessage = null;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;        

        vm.getByFilter    = getByFilter;   

        activate();

        function activate() {
            InvoicesService.setData(null); 

            if ($stateParams.hasOwnProperty('invoice_created') && $stateParams.invoice_created != undefined) {
                vm.message = $sce.trustAsHtml('<strong>Success!</strong> Invoice has been sent!');
                vm.classMessage = 'alert-success';
            }

            if ($stateParams.hasOwnProperty('errors') && $stateParams.errors != undefined) {              
                vm.message = $sce.trustAsHtml('<strong>Sorry!</strong> ' + $stateParams.errors);
                vm.classMessage = 'alert-danger';
            }

            if ($stateParams.hasOwnProperty('customer_created') && $stateParams.customer_created != undefined) {
                vm.message = $sce.trustAsHtml('<strong>Success!</strong> Customer has been added!');
                vm.classMessage = 'alert-success';
            }

            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };

        function getByFilter() {
            vm.query = {};

            vm.query['page'] = vm.page;

            if (vm.name !== '') {
                vm.query['name'] = vm.name;
            }

            if (vm.email !== '') {
                vm.query['email'] = vm.email;
            }

            InvoicesService.getClientsByFilter(vm.query).then(function(response) {                
                vm.clients = response.data.data;   
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);    

            }).catch(function(err) {
            });
        }                
    }

})();